export default "__VITE_ASSET__DFLQ1bId__"